export const CategoryAr = {
  "Categories": "الاصناف",
  "Categorie": "صنف",
}